import context from '../config/context'

const { links } = context
const support = links.support.endsWith('/')
  ? links.support
  : links.support + '/'
const serviceTerms = links['service-terms']
const privacyPolicy = links['privacy-policy']
const googleAPIServices = links['google-api-services']

export const SUPPORT = `${support}`
export const TERMS_OF_SERVICE = serviceTerms
export const PRIVACY_POLICY = privacyPolicy
export const GOOGLE_API_SERVICES = googleAPIServices
export const ROOT = '/'
export const LOGIN_PAGE = '/login'
export const LOGOUT_PAGE = '/logout'
export const SETTINGS_PAGE = '/users/settings'
export const PASSWORD_CHANGE = '/users/settings/password'
export const PASSWORD_RESET = '/users/password/recover'
export const CHANGE_PASSWORD_HELP = `${support}hc/en-us/articles/360000184306`
export const SETUP_MFA_MECHANISM = '/users/settings/mfa/setup'
export const DISABLE_MFA_MECHANISM = '/users/settings/mfa/disable'
export const LEARN_MORE_ABOUT_SECURITY_KEYS = `${support}hc/en-us/articles/360015179592#security_keys`
export const LEARN_MORE_ABOUT_SECURITY_KEYS_ERRORS = `${support}hc/en-us/articles/360020338552`
export const LEARN_MORE_ABOUT_AUTHENTICATOR_APP = `${support}hc/en-us/articles/360015179592#authenticator_app`
export const LEARN_MORE_ABOUT_2FA = `${support}hc/en-us/articles/360015179592`
export const SETUP_TOTP_MECHANISM = '/users/settings/mfa/setup/totp'
export const SETUP_WEB_AUTHN_MECHANISM = '/users/settings/mfa/setup/webauthn'
export const DOWNLOAD_AUTHENTICATOR_APP_APPLE_STORE =
  'https://itunes.apple.com/pt/app/google-authenticator/id388497605?mt=8'
export const DOWNLOAD_AUTHENTICATOR_APP_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
